import React from 'react'
import { Typography } from '@mui/material'
import styled from 'styled-components';

const StyledTypography = styled(Typography)`
  font-family: "Work Sans";
  font-size: 12px;
  letter-spacing: 0;
  line-height: 14px;
  text-align: right;
`;

const Paging = ({data}) => {

  return (
    <>
      <StyledTypography>
        {data.page_paging.page_current} / {data.page_paging.page_total}
      </StyledTypography>
    </>
  )
}

export default Paging
